'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoCalculator = function IoCalculator(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.3 2.5c0.7 0 1.2 0.5 1.2 1.3v32.5c0 0.7-0.5 1.2-1.2 1.2h-22.5c-0.8 0-1.3-0.5-1.3-1.2v-32.5c0-0.8 0.5-1.3 1.3-1.3h22.5z m-20 13.8v2.5h2.5v-2.5h-2.5z m0 5v2.5h2.5v-2.5h-2.5z m0 5v2.5h2.5v-2.5h-2.5z m7.5 7.5v-2.5h-7.5v2.5h7.5z m0-5v-2.5h-2.5v2.5h2.5z m0-5v-2.5h-2.5v2.5h2.5z m0-5v-2.5h-2.5v2.5h2.5z m5 15v-2.5h-2.5v2.5h2.5z m0-5v-2.5h-2.5v2.5h2.5z m0-5v-2.5h-2.5v2.5h2.5z m0-5v-2.5h-2.5v2.5h2.5z m5 15v-7.5h-2.5v7.5h2.5z m0-10v-2.5h-2.5v2.5h2.5z m0-5v-2.5h-2.5v2.5h2.5z m0-6.3v-6.2h-17.5v6.2h17.5z' })
        )
    );
};

exports.default = IoCalculator;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/calculator.js
// module id = 2207
// module chunks = 0